import {
    AvailablePhotographer,
    AvailableTimeslotWithPhotographer,
    AvailableTimeslotWithPhotographers
} from '../types';


export function getAllAvailableTimeslotsPerHour(
    availablePhotographers: AvailablePhotographer[]
): Map<string, Map<string, AvailableTimeslotWithPhotographers>> {
    if (availablePhotographers.length < 1) {
        return new Map<string, Map<string, AvailableTimeslotWithPhotographers>>();
    }

    let allTimeslots = availablePhotographers
        .reduce((acc, photographer) => {
            let res = photographer.availableTimeslots.map((availableTimeslot) => {
                return { timeslot: availableTimeslot, photographer };
            });

            return [...acc, ...res];
        }, [] as AvailableTimeslotWithPhotographer[])
        .sort((first, second) => (first.timeslot.time < second.timeslot.time ? -1 : 1));

    return transformTimeslotsWithPhotographers(allTimeslots);
}

function transformTimeslotsWithPhotographers(
    availableTimeslots: AvailableTimeslotWithPhotographer[]
): Map<string, Map<string, AvailableTimeslotWithPhotographers>> {
    return availableTimeslots.reduce((acc, availableTimeslot) => {
        let [hour, _] = availableTimeslot.timeslot.time.split(':');

        if (!acc.has(hour)) {
            let newTimeslot = new Map<string, AvailableTimeslotWithPhotographers>();
            newTimeslot.set(availableTimeslot.timeslot.time, {
                timeslot: availableTimeslot.timeslot,
                photographers: [availableTimeslot.photographer]
            });
            acc.set(hour, newTimeslot);
        } else {
            let previous = acc.get(hour);

            let previousTimeslotWithPhotographers = previous.get(availableTimeslot.timeslot.time);
            if (!previousTimeslotWithPhotographers) {
                previous.set(availableTimeslot.timeslot.time, {
                    timeslot: availableTimeslot.timeslot,
                    photographers: [
                        availableTimeslot.photographer
                    ]
                });
            } else {
                previous.set(availableTimeslot.timeslot.time, {
                    timeslot: availableTimeslot.timeslot,
                    photographers: [
                        ...previousTimeslotWithPhotographers.photographers,
                        availableTimeslot.photographer
                    ]
                });
            }

            acc.set(hour, previous);
        }

        return acc;
    }, new Map<string, Map<string, AvailableTimeslotWithPhotographers>>());
}

